import { useCallback, useState, useEffect } from "react";
import { useTypedSelector } from "@/stores";
import { getAuthLink } from "@form/services/sendingme";
import { toast } from "react-toastify";
import useAccount from "@/hooks/useAccount";

import type { UserSendingme } from "@form/services/account";

export default function useUserSendingme() {
  const [sendingme, setSendingme] = useState<UserSendingme | null>(null);
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState("");
  const { login, isLogin } = useAccount();
  const [authLink, setAuthLink] = useState("");

  const userInfo = useTypedSelector((state) => {
    return state.account.userInfo;
  });

  useEffect(() => {
    if (userInfo?.discord) {
      setSendingme(userInfo.sendingme);
      setConnecting(false);
      setError("");
    } else {
      setSendingme(null);
      setConnecting(false);
      setError("");
    }
  }, [userInfo?.sendingme]);

  useEffect(() => {
    if (userInfo && !userInfo?.sendingme && isLogin) {
      getAuthLink().then((res) => {
        setAuthLink(res.authLink);
      });
    }
  }, [isLogin, userInfo?.sendingme]);

  useEffect(() => {
    if (connecting) {
      const timer = setTimeout(() => {
        setConnecting(false);
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [connecting]);

  const connect = useCallback(async () => {
    if (!userInfo) {
      return login();
    }
    if (userInfo.sendingme) {
      return;
    }
    setConnecting(true);
  }, [userInfo, login]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      setError("");
    }
  }, [error]);

  return {
    sendingme,
    connecting,
    error,
    connect,
    authLink,
  };
}
